import MD5 from 'crypto-js/md5'

export const getDomain = (url: string) => {
  try {
    return new URL(url).origin
  } catch {
    return null
  }
}

export const hashId = (id: number) => {
  return MD5(String(id)).toString()
}
